import { render, staticRenderFns } from "./integratedMarketing.vue?vue&type=template&id=d5721ade&scoped=true"
import script from "./integratedMarketing.vue?vue&type=script&lang=js"
export * from "./integratedMarketing.vue?vue&type=script&lang=js"
import style0 from "./integratedMarketing.vue?vue&type=style&index=0&id=d5721ade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5721ade",
  null
  
)

export default component.exports